import React from "react";
import { Helmet } from "react-helmet-async";

import ContactHero from "../components/contact/ContactHero";
import GlobalCta from "../components/global/GlobalCta";
import FVFRThermalMethods from "../components/freezer-van-for-rent/FVFRThermalMethods";
import FVFRFleetSpec from "../components/freezer-van-for-rent/FVFRFleetSpec";
import FVFRCargoTypes from "../components/freezer-van-for-rent/FVFRCargoTypes";
import FVFRPricing from "../components/freezer-van-for-rent/FVFRPricing";
import FVFRDeliveryZones from "../components/freezer-van-for-rent/FVFRDeliveryZones";
import FVFRWhyChoose from "../components/freezer-van-for-rent/FVFRWhyChoose";
import FVFRFaq from "../components/freezer-van-for-rent/FVFRFaq";

import { freezerVanForRentSections } from "../components/freezer-van-for-rent/freezerVanForRentSections";
import "../components/freezer-van-for-rent/freezer-van-for-rent.css";
import "../components/home/home.css";

const FreezerVanForRent = () => {
  const renderSection = (section, index) => {
    switch (section.type) {
      case "fvfr-hero":
        return (
          <ContactHero
            key={index}
            variant="freezer-van-for-rent"
            title={section.title}
            paragraphs={section.paragraphs}
          />
        );

      case "fvfr-thermal-methods":
        return (
          <FVFRThermalMethods
            key={index}
            title={section.title}
            description={section.description}
            methods={section.methods}
          />
        );

      case "fvfr-fleet-spec":
        return (
          <FVFRFleetSpec
            key={index}
            title={section.title}
            description={section.description}
            image={section.image}
            imageAlt={section.imageAlt}
            refrigerationRows={section.refrigerationRows}
            payloadRows={section.payloadRows}
            note={section.note}
          />
        );

      case "fvfr-cargo-types":
        return (
          <FVFRCargoTypes
            key={index}
            title={section.title}
            description={section.description}
            cargoTypes={section.cargoTypes}
          />
        );

      case "fvfr-pricing":
        return (
          <FVFRPricing
            key={index}
            title={section.title}
            descriptionMain={section.descriptionMain}
            descriptionNote={section.descriptionNote}
          />
        );

      case "fvfr-delivery-zones":
        return (
          <FVFRDeliveryZones
            key={index}
            title={section.title}
            description={section.description}
            zones={section.zones}
          />
        );

      case "fvfr-why-choose":
        return (
          <FVFRWhyChoose
            key={index}
            title={section.title}
            description={section.description}
            reasons={section.reasons}
          />
        );

      case "fvfr-faq":
        return (
          <FVFRFaq
            key={index}
            title={section.title}
            faqs={section.faqs}
          />
        );

      case "cta":
        return (
          <GlobalCta
            key={index}
            title={section.title}
            paragraphs={section.paragraphs}
          />
        );

      default:
        return null;
    }
  };

  return (
    <>
      <Helmet>
        <title>Freezer Van for Rent in Dubai | Deep Freeze Vans for Frozen Cargo</title>
        <meta
          name="description"
          content="Chiller Fleet Transport provides freezer van for rent in Dubai & Sharjah for ice creams, seafoods, & packaged frozen goods available all across UAE. Hire today."
        />
        <link rel="canonical" href="https://chillerfleet.com/freezer-van-for-rent" />
        <meta property="og:title" content="Freezer Van for Rent in Dubai | Deep Freeze Vans for Frozen Cargo" />
        <meta
          property="og:description"
          content="Chiller Fleet Transport provides freezer van for rent in Dubai & Sharjah for ice creams, seafoods, & packaged frozen goods available all across UAE. Hire today."
        />
        <meta property="og:url" content="https://chillerfleet.com/freezer-van-for-rent" />
        <meta name="twitter:title" content="Freezer Van for Rent in Dubai | Deep Freeze Vans for Frozen Cargo" />
        <meta
          name="twitter:description"
          content="Chiller Fleet Transport provides freezer van for rent in Dubai & Sharjah for ice creams, seafoods, & packaged frozen goods available all across UAE. Hire today."
        />
      </Helmet>

      {freezerVanForRentSections.map(renderSection)}
    </>
  );
};

export default FreezerVanForRent;
